<p-toast position="top-right"></p-toast>

<p-sidebar [(visible)]="showDetailMartPartnerSideBar"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'700px'}">
    <ng-template pTemplate="header">
        <div style="margin: 20px 0px 0px 5px;">
            <div class="header-title">Detail Mart Partner</div>
            <div class="header-sub-title"></div>
        </div>
    </ng-template>

    <div class="bx-pager bx-default-pager">
        <div class="bx-pager-item active" (click)="nextTab(createPartnerTab.CompanyDetails)">
            <a class="bx-pager-link " data-slide-index="0">Company Details</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item" [class.active]="activeCreatePartnerTab !== createPartnerTab.CompanyDetails"
             (click)="nextTab(createPartnerTab.PersonalDetails)">
            <a class="bx-pager-link" data-slide-index="1">Personal Details</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item" 
             [class.active]="(activeCreatePartnerTab === createPartnerTab.Service || activeCreatePartnerTab === createPartnerTab.Proposal)"
             (click)="nextTab(createPartnerTab.Service)">
            <a class="bx-pager-link" data-slide-index="2">Service</a>
            <div class="arrow">

            </div>
        </div>
        <div class="bx-pager-item" [class.active]="activeCreatePartnerTab === createPartnerTab.Proposal"
             (click)="nextTab(createPartnerTab.Proposal)">
            <a class="bx-pager-link" data-slide-index="3">Proposal</a>
        </div>
    </div>

    <div *ngIf="loading" style="text-align: center; padding: 30px;">
        <p-progressSpinner [style]="{width: '40px', height: '40px'}" styleClass="custom-spinner" strokeWidth="5"
                           fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <div *ngIf="!loading">
        <div class="promo-detail-body" *ngIf="activeCreatePartnerTab === createPartnerTab.CompanyDetails">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 230px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="merchant-body-title">Complete all the information you know, otherwise leave blank</div>

                <div class="merchant-form">
                    <div class="merchant-label">Registered company name (same as SEC document) *</div>
                    <input type="text" [(ngModel)]="merchant.BusinessName" placeholder="Type here…" pInputText [disabled]="true" />
                </div>

                <div class="merchant-form">
                    <div class="merchant-label">Registered company address (same as SEC document) *</div>
                    <input type="text" [(ngModel)]="merchant.BusinessAddress" placeholder="Address…" pInputText [disabled]="true" />
                </div>

                <div class="merchant-form">
                    <div class="merchant-label">Trading name (what will be published in app) *</div>
                    <input type="text" [(ngModel)]="merchant.TradingName" placeholder="Type here…" pInputText [disabled]="true" />
                </div>

                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Company Phone</div>
                            <input type="text" [(ngModel)]="merchant.BusinessPhone" placeholder="+63" pInputText [disabled]="true" />
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Company Email</div>
                            <input type="text" [(ngModel)]="merchant.BusinessEmail" placeholder="Email" pInputText [disabled]="true" />
                        </div>
                    </div>
                </div>
            </p-scrollPanel>
            <hr class="hr-filter" />
            <div class="flex justify-content-end mrg-10-0px">
                <button class="bluedark-btn" pButton label="Next" (click)="nextTab(createPartnerTab.PersonalDetails)"></button>
            </div>
        </div>

        <div class="promo-detail-body" *ngIf="activeCreatePartnerTab === createPartnerTab.PersonalDetails">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 230px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="merchant-body-title">Complete all the information you know, otherwise leave blank</div>

                <div class="merchant-form">
                    <div class="merchant-label">Company position *</div>
                    <p-dropdown placeholder="Select" [(ngModel)]="merchant.CompanyPosition" [options]="companyPositions"
                                optionLabel="name" optionValue="value" [showClear]="true" [disabled]="true"></p-dropdown>
                </div>

                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-30">
                        <div class="merchant-form">
                            <div class="merchant-label">Salutation *</div>
                            <p-dropdown placeholder="Select" [(ngModel)]="merchant.Salutation" [options]="salutations"
                                        optionLabel="name" optionValue="value" [showClear]="true" [disabled]="true"></p-dropdown>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-70">
                        <div class="merchant-form">
                            <div class="merchant-label">First Name *</div>
                            <input type="text" [(ngModel)]="merchant.FirstName" placeholder="First Name" pInputText [disabled]="true" />
                        </div>
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-70">
                        <div class="merchant-form">
                            <div class="merchant-label">Last Name *</div>
                            <input type="text" [(ngModel)]="merchant.LastName" placeholder="Last Name" pInputText [disabled]="true" />
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-30">
                        <div class="merchant-form">
                            <div class="merchant-label">Suffix</div>
                            <p-dropdown placeholder="Select" [(ngModel)]="merchant.Suffix" [options]="suffixes"
                                        optionLabel="name" optionValue="value" [showClear]="true" [disabled]="true"></p-dropdown>
                        </div>
                    </div>
                </div>

                <div class="merchant-form">
                    <div class="merchant-label">Home Address</div>
                    <input type="text" [(ngModel)]="merchant.Address" placeholder="Address" pInputText [disabled]="true" />
                </div>

                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <input type="text" [(ngModel)]="merchant.City" placeholder="City" pInputText [disabled]="true" />
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <input type="text" [(ngModel)]="merchant.PostalCode" placeholder="Zip Code" pInputText [disabled]="true" />
                        </div>
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Date of Birth</div>
                            <p-calendar inputId="basic" [(ngModel)]="merchant.Birthday" placeholder="mm/dd/yyyy" [disabled]="true"></p-calendar>
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Nationality</div>
                            <p-dropdown placeholder="Nationality" [(ngModel)]="merchant.NationalityId" [options]="natioanlities"
                                        optionLabel="Name" optionValue="Id" [showClear]="true" [disabled]="true"></p-dropdown>
                        </div>
                    </div>
                </div>

                <div class="flex flex-row">
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Cellphone Number *</div>
                            <input type="text" [(ngModel)]="merchant.Phone" placeholder="+63" pInputText [disabled]="true" />
                        </div>
                    </div>
                    <div class="merchant-column merchant-column-50">
                        <div class="merchant-form">
                            <div class="merchant-label">Work Email *</div>
                            <input type="text" [(ngModel)]="merchant.Email" placeholder="Email" pInputText [disabled]="true" />
                        </div>
                    </div>
                </div>
            </p-scrollPanel>
            <hr class="hr-filter" />
            <div class="flex justify-content-end  mrg-10-0px">
                <button class="bluedark-btn" style="float: right;" pButton label="Next" (click)="nextTab(createPartnerTab.Service)"></button>
            </div>
        </div>

        <div class="promo-detail-body" *ngIf="activeCreatePartnerTab === createPartnerTab.Service">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 230px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="merchant-body-title">Select all the services that apply</div>

                <div class="field-checkbox">
                    <p-checkbox name="group1" value="merchantServiceTypeEnum.Delivery" [value]="merchantServiceTypeEnum.Delivery"
                                [(ngModel)]="merchant.MerchantServiceTypes" inputId="merchantServiceTypeEnum.Delivery" [disabled]="true"></p-checkbox>
                    <label for="merchantServiceTypeEnum.Delivery" class="mst-label"><img src="/Content/xpress-app/images/svg/delivery.svg" /> <span class="mst-label-text">Delivery</span></label>
                </div>

                <div class="field-checkbox">
                    <p-checkbox name="group1" value="merchantServiceTypeEnum.PickUp" [value]="merchantServiceTypeEnum.PickUp"
                                [(ngModel)]="merchant.MerchantServiceTypes" inputId="merchantServiceTypeEnum.PickUp" [disabled]="true"></p-checkbox>
                    <label for="merchantServiceTypeEnum.PickUp" class="mst-label"><img src="/Content/xpress-app/images/svg/pick-up.svg" /> <span class="mst-label-text">Pick-up</span></label>
                </div>

                <div class="field-checkbox">
                    <p-checkbox name="group1" value="merchantServiceTypeEnum.Booking" [value]="merchantServiceTypeEnum.Booking"
                                [(ngModel)]="merchant.MerchantServiceTypes" inputId="merchantServiceTypeEnum.Booking" [disabled]="true"></p-checkbox>
                    <label for="merchantServiceTypeEnum.Booking" class="mst-label"><img src="/Content/xpress-app/images/svg/booking.svg" /> <span class="mst-label-text">Booking</span></label>
                </div>
            </p-scrollPanel>
            <hr class="hr-filter" />
            <div class="flex justify-content-end  mrg-10-0px">
                <button class="bluedark-btn" style="float: left;" pButton label="Next" (click)="nextTab(createPartnerTab.Proposal)"></button>
            </div>
        </div>

        <div class="promo-detail-body" *ngIf="activeCreatePartnerTab === createPartnerTab.Proposal">
            <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 240px)'}"
                           [styleClass]="'app-scrollpanel'">

                <div class="merchant-body-title">Select the Partnership terms</div>

                <div class="merchant-form">
                    <div class="merchant-label">Partner stores *</div>
                    <input class="input-test-store-name italic" type="text" [(ngModel)]="merchant.StoreName" placeholder="Enter store" pInputText [disabled]="true"/>
                </div>
            </p-scrollPanel>
        </div>
    </div>

</p-sidebar>